import type { PiniaPluginContext } from 'pinia';
import socketio from '@/common/utils/socketio.connection';

export default function wsPlugin(context: PiniaPluginContext) {
  if (context.store.ws) {
    Object.entries(context.store.ws).forEach(
      ([channel, listener]) => socketio.on(channel, listener)
    );
  }

  if (context.options.ws) {
    Object.entries(context.options.ws).forEach(([channel, actionName]) => {
      if (typeof context.store[actionName] === 'function') {
        socketio.on(channel, context.store[actionName] as (args: any) => void);
      }
    });
  }
}
